import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $state, $q, $filter, AccountService, ModalService, ViewModelService) {
    var ctrl = Object.create(BaseCtrl);
    ctrl.init = function () {
        initialiseScopeVariables();
    };

    function initialiseScopeVariables() {
        $scope.isEditingContactDetails = false;
        $scope.hideFields = ['AddressLine3'];
    }

    function getUpdatedAccountContactDetails() {
        var updatedAccount = {};
        var accountHolder = {};
        updatedAccount.accountNumber = $scope.accountInfoCopy.accountNumber;

        if ($scope.accountInfoCopy.subtype === 'Person') {
            accountHolder.contactName = $scope.accountInfoCopy.contactName;
            accountHolder.subtype = 'Person';
            accountHolder.firstName = $scope.accountInfoCopy.firstName;
            accountHolder.lastName = $scope.accountInfoCopy.lastName;
            accountHolder.primaryAddress = $scope.accountInfoCopy.primaryAddress;

            if ($scope.accountInfoCopy.primaryPhoneType) {
                accountHolder.primaryPhoneType = $scope.accountInfoCopy.primaryPhoneType;
            } else if ($scope.accountInfoCopy.homeNumber) {
                accountHolder.primaryPhoneType = 'home';
            }
            var home = angular.element('#HomeNumber').val();
            var work = angular.element('#WorkNumber').val();
            var cell = angular.element('#CellNumber').val();
            var fax = angular.element('#FaxNumber').val();

            if (home != undefined && home != null && home.trim() != '') {
                accountHolder.homeNumberExtension = home.split('x')[1].trim().replace(/\D/g, '');
                accountHolder.homeNumber = home.split('x')[0].trim().replace(/\D/g, '');
            }
            if (work != undefined && work != null && work.trim() != '') {
                accountHolder.workNumberExtension = work.split('x')[1].trim().replace(/\D/g, '');
                accountHolder.workNumber = work.split('x')[0].trim().replace(/\D/g, '');
            }
            if (fax != undefined && fax != null && fax.trim() != '') {
                accountHolder.faxNumber = fax.split('x')[0].trim().replace(/\D/g, '');
            }

            accountHolder.cellNumber = $scope.accountInfoCopy.cellNumber ? $scope.accountInfoCopy.cellNumber : "";
            accountHolder.emailAddress1 = $scope.accountInfoCopy.emailAddress1 ? $scope.accountInfoCopy.emailAddress1 : null;
            accountHolder.emailAddress2 = $scope.accountInfoCopy.emailAddress2 ? $scope.accountInfoCopy.emailAddress2 : null;
            accountHolder.ProducerCode = '';

            updatedAccount.accountHolder = accountHolder;
        } else if ($scope.accountInfoCopy.subtype === 'Company') {

            var _home = angular.element('#HomeNumber').val();
            var _work = angular.element('#WorkNumber').val();
            var _cell = angular.element('#CellNumber').val();
            var _fax = angular.element('#FaxNumber').val();

            if (_home != undefined || _home != null) {

                if (_home.trim() != '') {
                    accountHolder.homeNumberExtension = _home.split('x')[1].trim().replace(/\D/g, '');
                    accountHolder.homeNumber = _home.split('x')[0].trim().replace(/\D/g, '');
                } else {
                    accountHolder.homeNumberExtension = '';
                    accountHolder.homeNumber = '';
                }
            } else {
                accountHolder.homeNumberExtension = '';
                accountHolder.homeNumber = '';
            }
            if (_work != undefined || _work != null) {

                if (_work.trim() != '') {
                    accountHolder.workNumberExtension = _work.split('x')[1].trim().replace(/\D/g, '');
                    accountHolder.workNumber = _work.split('x')[0].trim().replace(/\D/g, '');
                } else {
                    accountHolder.workNumberExtension = '';
                    accountHolder.workNumber = '';
                }
            } else {
                accountHolder.workNumberExtension = '';
                accountHolder.workNumber = '';
            }
            if (_cell != undefined || _cell != null) {
                if (_cell.trim() != '') {
                    accountHolder.cellNumber = _cell.split('x')[0].trim().replace(/\D/g, '');
                    accountHolder.cellNumber = "";
                } else {
                    accountHolder.cellNumberExtension = '';
                    accountHolder.cellNumber = '';
                }
            } else {
                accountHolder.cellNumberExtension = '';
                accountHolder.cellNumber = '';
            }
            if (_fax != undefined || _fax != null) {
                if (_fax.trim() != '') {
                    accountHolder.faxNumber = _fax.split('x')[0].trim().replace(/\D/g, '');
                } else {
                    accountHolder.faxNumber = '';
                }
            } else {
                accountHolder.faxNumber = ' ';
            }
            accountHolder.contactName = $scope.accountInfoCopy.contactName;
            accountHolder.subtype = 'Company';
            accountHolder.primaryAddress = $scope.accountInfoCopy.primaryAddress;
            accountHolder.primaryPhoneType = $scope.accountInfoCopy.primaryPhoneType ? $scope.accountInfoCopy.primaryPhoneType : 'work';
            accountHolder.cellNumber = $scope.accountInfoCopy.cellNumber ? $scope.accountInfoCopy.cellNumber : "";
            accountHolder.emailAddress1 = $scope.accountInfoCopy.emailAddress1 ? $scope.accountInfoCopy.emailAddress1 : null;
            accountHolder.emailAddress2 = $scope.accountInfoCopy.emailAddress2 ? $scope.accountInfoCopy.emailAddress2 : null;
            accountHolder.ProducerCode = '';

            updatedAccount.accountHolder = accountHolder;
        }
        return updatedAccount;
    }

    $scope.is_usZipCode = function (value) {
        if (value == '' || value == undefined) {
            $scope.error_exist = false;
        } else {
            var regexp = /^[0-9a-zA-Z]{5}(?:-[0-9a-zA-Z]{4})?$/;
            if (value != '' && !regexp.test(value)) {
                $scope.error_exist = true;
            } else {
                $scope.error_exist = false;
            }
        }
    };

    $scope.is_auZipCode = function (value) {
        if (value == '' || value == undefined) {
            $scope.error_exist = false;
        } else {
            var regexp = /^[0-9]{4}$/;
            if (value != '' && !regexp.test(value)) {
                $scope.error_exist = true;
            } else {
                $scope.error_exist = false;
            }
        }
    };

    //for canada country
    $scope.is_caZipCode = function (value) {
        if (value == '' || value == undefined) {
            $scope.error_exist = false;
        } else {
            var regexp = /^[A-Za-z]\d[A-Za-z][ ]\d[A-Za-z]\d$/;
            if (value != '' && !regexp.test(value)) {
                $scope.error_exist = true;
            } else {
                $scope.error_exist = false;
            }
        }
    };

    $scope.$watch('accountInfoCopyView.primaryAddress.postalCode.value', function (value) {
        if ($scope.accountInfoCopyView && $scope.accountInfoCopyView.primaryAddress.country.value.code == 'US' || $scope.accountInfoCopyView.primaryAddress.country.value.code == 'MX') $scope.is_usZipCode(value);
        if ($scope.accountInfoCopyView && $scope.accountInfoCopyView.primaryAddress.country.value.code == 'CA' && $scope.accountInfoCopyView.primaryAddress.postalCode.value != undefined) $scope.is_caZipCode(value);
    });

    $scope.$watch('accountInfoCopyView.primaryAddress.country.value', function (value) {
        if ($scope.accountInfoCopyView && $scope.accountInfoCopyView.primaryAddress.country.value.code == 'US') {
            if ($scope.accountInfoCopyView.primaryAddress && $scope.accountInfoCopyView.primaryAddress.postalCode.value != "") {
                $scope.is_usZipCode($scope.accountInfoCopyView.primaryAddress.postalCode.value);
            }
            var StateListPromise = AccountService.getStates(value.code);
            StateListPromise.then(function (data) {

                $scope.availableStates = [];
                angular.forEach(data, function (result, resultkey) {
                    $scope.result = result.split('~');
                    $scope.availableStates.push($scope.result);
                });
                $scope.desiredArray = [];
                angular.forEach($scope.availableStates, function (splitedvalues) {
                    $scope.desiredArray.push({ name: splitedvalues[0], code: splitedvalues[1] });
                });
                $scope.selected = {
                    "value": $scope.desiredArray[0],
                    "availableStates": $scope.desiredArray
                };

                $scope.accountInfoCopyView.primaryAddress.state.value = $scope.selected.availableStates[0].code;
            });
        }
        if ($scope.accountInfoCopyView.primaryAddress && $scope.accountInfoCopyView.primaryAddress.country.value.code == 'MX') {
            if ($scope.accountInfoCopyView.primaryAddress && $scope.accountInfoCopyView.primaryAddress.postalCode.value != "") {
                $scope.is_usZipCode($scope.accountInfoCopyView.primaryAddress.postalCode.value);
            }
        }

        if ($scope.accountInfoCopyView && $scope.accountInfoCopyView.primaryAddress.country.value.code == 'CA') {
            if ($scope.accountInfoCopyView.primaryAddress && $scope.accountInfoCopyView.primaryAddress.postalCode.value != "") {
                $scope.is_caZipCode($scope.accountInfoCopyView.primaryAddress.postalCode.value);
            }
            var _StateListPromise = AccountService.getStates(value.code);
            _StateListPromise.then(function (data) {

                $scope.availableStates = [];
                angular.forEach(data, function (result, resultkey) {
                    $scope.result = result.split('~');
                    $scope.availableStates.push($scope.result);
                });
                $scope.desiredArray = [];
                angular.forEach($scope.availableStates, function (splitedvalues) {
                    $scope.desiredArray.push({ name: splitedvalues[0], code: splitedvalues[1] });
                });
                $scope.selected = {
                    "value": $scope.desiredArray[0],
                    "availableStates": $scope.desiredArray
                };
                $scope.accountInfoCopyView.primaryAddress.state.value = $scope.selected.availableStates[0].code;
            });
        }
        if ($scope.accountInfoCopyView && $scope.accountInfoCopyView.primaryAddress.country.value.code != 'US' && $scope.accountInfoCopyView.primaryAddress.country.value.code != 'MX' && $scope.accountInfoCopyView.primaryAddress.country.value.code != 'CA') {
            $scope.selected.value = '';
            $scope.accountInfoCopyView.primaryAddress.state.value = '';
            delete $scope.accountInfoCopyView.primaryAddress.state.value;
        }
    });
    $scope.selectedState = function (selected) {
        $scope.address.state.value = selected.code;
    };

    ctrl.cancelEditAccountContactDetails = function () {
        $scope.isEditingContactDetails = false;
    };

    ctrl.replaceNullValues = function () {
        $scope.accountInfoCopy.homeNumber = $scope.accountInfoCopy.homeNumber || null;
        $scope.accountInfoCopy.workNumber = $scope.accountInfoCopy.workNumber || null;
        $scope.accountInfoCopy.cellNumber = $scope.accountInfoCopy.cellNumber || null;
        $scope.accountInfoCopy.faxNumber = $scope.accountInfoCopy.faxNumber || null;
        $scope.accountInfoCopy.emailAddress1 = $scope.accountInfoCopy.emailAddress1 || '';
        $scope.accountInfoCopy.emailAddress2 = $scope.accountInfoCopy.emailAddress2 || '';
        $scope.accountInfoCopy.primaryPhoneType = $scope.accountInfoCopy.primaryPhoneType || '';
        $scope.accountInfoCopy.primaryAddress.addressLine1 = $scope.accountInfoCopy.primaryAddress.addressLine1 || '';
        $scope.accountInfoCopy.primaryAddress.addressLine2 = $scope.accountInfoCopy.primaryAddress.addressLine2 || '';
        $scope.accountInfoCopy.primaryAddress.city = $scope.accountInfoCopy.primaryAddress.city || '';
        $scope.accountInfoCopy.primaryAddress.country = $scope.accountInfoCopy.primaryAddress.country || '';
        $scope.accountInfoCopy.primaryAddress.county = $scope.accountInfoCopy.primaryAddress.county || '';
        $scope.accountInfoCopy.primaryAddress.postalCode = $scope.accountInfoCopy.primaryAddress.postalCode || '';
        $scope.accountInfoCopy.primaryAddress.state = $scope.accountInfoCopy.primaryAddress.state || '';
    };

    ctrl.updateContactDetails = function (contactDetailsForm, accountInfoCopyView) {
        contactDetailsForm.submitted = true;
        if (contactDetailsForm.invalid) {
            return;
        }
        if (accountInfoCopyView.primaryAddress.country.value.code != "CA" && accountInfoCopyView.primaryAddress.country.value.code != "AU") {
            var regexp = /^[0-9a-zA-Z]{5}(?:-[0-9a-zA-Z]{4})?$/;
            if (accountInfoCopyView.primaryAddress.postalCode.value == '') {
                $scope.worksubmitted = true;
                return $scope.worksubmitted;
            }
            if (accountInfoCopyView.primaryAddress.postalCode.value != '' && !regexp.test(accountInfoCopyView.primaryAddress.postalCode.value)) {
                $scope.error_exist = true;
                return $scope.error_exist;
            } else {
                $scope.error_exist = false;
            }
        }

        if (accountInfoCopyView.primaryAddress.country.value.code == "CA") {
            var regexp = /^[A-Za-z]\d[A-Za-z][ ]\d[A-Za-z]\d$/;
            if (accountInfoCopyView.primaryAddress.postalCode.value == '') {
                $scope.worksubmitted = true;
                return $scope.worksubmitted;
            }
            if (accountInfoCopyView.primaryAddress.postalCode.value != '' && !regexp.test(accountInfoCopyView.primaryAddress.postalCode.value)) {
                $scope.error_exist = true;
                return $scope.error_exist;
            } else {
                $scope.error_exist = false;
            }
        }
        if (accountInfoCopyView.primaryAddress.country.value.code == "AU") {
            var regexp = /^[0-9]{4}$/;
            if (accountInfoCopyView.primaryAddress.postalCode.value == '') {
                $scope.worksubmitted = true;
                return $scope.worksubmitted;
            }
            if (accountInfoCopyView.primaryAddress.postalCode.value != '' && !regexp.test(accountInfoCopyView.primaryAddress.postalCode.value)) {
                $scope.error_exist = true;
                return $scope.error_exist;
            } else {
                $scope.error_exist = false;
            }
        }
        if (contactDetailsForm.contactDetailsForm.WorkNumber.$error.pattern == true) {
            $scope.worksubmitted = true;
            return $scope.worksubmitted;
        }
        if ($scope.accountInfoCopy.workNumber != '' && $scope.accountInfoCopy.workNumber != null && $scope.accountInfoCopy.workNumber === undefined) {
            return;
        }
        if ($scope.accountInfoCopy.cellNumber !== '' && $scope.accountInfoCopy.cellNumber !== null && $scope.accountInfoCopy.cellNumber === undefined) {
            return;
        }
        if ($scope.accountInfoCopy.faxNumber !== '' && $scope.accountInfoCopy.faxNumber !== null && $scope.accountInfoCopy.faxNumber === undefined) {
            return;
        }
        var updatedAccount = getUpdatedAccountContactDetails();
        var updateContactDetailsPromise = AccountService.updateAccountDetails(updatedAccount);
        $scope.updateContactDetailsPromise = updateContactDetailsPromise;
        $q.when(updateContactDetailsPromise).then($scope.mapAccountDetails).then(function () {
            $scope.isEditingContactDetails = false;
        }).then(function () {
            ModalService.showInfo('gateway.views.account-detail.Saved Title', 'gateway.views.account-detail.Saved Message');
        }).catch(function () {});
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$q', '$filter', 'AccountService', 'ModalService', 'ViewModelService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/account/AccountSummaryCtrl.js
// module id = 1689
// module chunks = 0